import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div`
  background: var(--dark);
  width: 180px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  transition: left 0.3s ease;
  overflow-y: auto;

  @media (max-width: 768px) {
    left: ${({ isOpen }) => (isOpen ? '0' : '-180px')};
  }
`;

const Logo = styled.div`
  h2 {
    color: var(--light);
    font-size: 1.5rem;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--gray);
    text-align: center;
  }
`;

const Nav = styled.nav`
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin: 6px 0;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      left: -15px;
      top: 0;
      height: 100%;
      width: 3px;
      background: var(--primary);
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    &:hover::before {
      opacity: 1;
    }
  }

  a {
    color: #bdbdbd;
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    display: block;
    padding: 8px 12px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      color: var(--light);
      background: var(--card-hover);
      transform: translateX(5px);
    }

    &.active {
      color: var(--dark);
      background: var(--primary);
    }

    i {
      margin-right: 8px;
      width: 20px;
      text-align: center;
    }
  }
`;

const DropdownToggle = styled.div`
  color: #bdbdbd;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    color: var(--light);
    background: var(--card-hover);
    transform: translateX(5px);
  }

  &.active-parent {
    color: var(--light);
    background: rgba(0, 212, 255, 0.12);
  }
`;

const SubMenu = styled.ul`
  padding-left: 16px;
  margin: 4px 0 12px 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.35s ease;

  &.open {
    max-height: 400px; /* increased a bit to accommodate new item */
  }

  li a {
    font-size: 0.9rem;
    padding: 6px 12px 6px 24px;
  }
`;

const Arrow = styled.span`
  font-size: 0.8rem;
  transition: transform 0.25s ease;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const [cryptoProjectsOpen, setCryptoProjectsOpen] = useState(false);

  const toggleCryptoProjects = () => {
    setCryptoProjectsOpen(!cryptoProjectsOpen);
  };

  return (
    <SidebarContainer isOpen={isOpen} className="sidebar">
      <Logo>
        <h2>ModMedia Network™</h2>
      </Logo>

      <Nav>
        <ul>
          <li>
            <NavLink to="/" onClick={toggleSidebar} end>
              Home
            </NavLink>
          </li>

          <li>
            <NavLink to="/radio" onClick={toggleSidebar}>
              📻 Radio
            </NavLink>
          </li>

          <li>
            <DropdownToggle
              onClick={toggleCryptoProjects}
              className={cryptoProjectsOpen ? 'active-parent' : ''}
            >
              Modmedia.Network Crypto Projects
              <Arrow isOpen={cryptoProjectsOpen}>▼</Arrow>
            </DropdownToggle>

            <SubMenu className={cryptoProjectsOpen ? 'open' : ''}>
              <li>
                <NavLink to="/snowden" onClick={toggleSidebar}>
                  Snowden Crypto Collectible
                </NavLink>
              </li>
              <li>
                <NavLink to="/snowden-nfts" onClick={toggleSidebar}>
                  Cryptographer's EXILE Comic
                </NavLink>
              </li>
              <li>
                <NavLink to="/kaspa-future-economy" onClick={toggleSidebar}>
                  Kaspa Crypto Overview
                </NavLink>
              </li>
              <li>
                <a
                  href="https://www.kaspasphere.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={toggleSidebar}
                >
                  KaspaSphere DAO
                </a>
              </li>
              <li>
                <a
                  href="https://kaspanet.online"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={toggleSidebar}
                >
                  Kaspanet© Online
                </a>
              </li>
            </SubMenu>
          </li>

          <li>
            <NavLink to="/gaming" onClick={toggleSidebar}>
              Gaming
            </NavLink>
          </li>

          <li>
            <NavLink to="/support" onClick={toggleSidebar}>
              OFFICIAL PARTNERS
            </NavLink>
          </li>

          <li>
            <NavLink to="/archived-articles" onClick={toggleSidebar}>
              Archived Articles
            </NavLink>
          </li>

          <li>
            <NavLink to="/analytics" onClick={toggleSidebar}>
              <i className="fas fa-chart-pie"></i> Analytics
            </NavLink>
          </li>

          <li>
            <NavLink to="/about" onClick={toggleSidebar}>
              About / CONTACT
            </NavLink>
          </li>

          <li>
            <a
              href="https://bio.site/modmedia"
              target="_blank"
              rel="noopener noreferrer"
              onClick={toggleSidebar}
            >
              ModMedia Designed Websites Portfolio
            </a>
          </li>
        </ul>
      </Nav>
    </SidebarContainer>
  );
};

export default Sidebar;
